import { Component, PLATFORM_ID, inject } from '@angular/core';
import {TranslationService} from "../../../core/services/translation.service";
import {VHostService} from "../../../core/services/v-host.service";
import {CustomerService} from "../../../data/services/customer.service";
import {InvoiceInfo} from "../../../data/models/invoiceInfo.model";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {CssPropertiesEnum} from "../../../core/models/css-properties.enum";
import { CurrencyPipe, DatePipe, isPlatformBrowser } from "@angular/common";
import {ActivatedRoute} from "@angular/router";
import {CssPropertyPipe} from "../../../core/pipes/css-property.pipe";
import {MatCard, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {SafeResourcePipe} from "../../../core/pipes/safe-resource.pipe";
import {ApplyIfNotEmptyDirective} from "../../../core/directives/apply-if-not-empty.directive";

@Component({
  selector: 'app-customer-invoice',
  templateUrl: './customer-invoice.component.html',
  styleUrls: ['./customer-invoice.component.css'],
  imports: [
    MatPaginator,
    MatCard,
    MatCardHeader,
    DatePipe,
    CurrencyPipe,
    SafeResourcePipe,
    MatCardTitle,
    MatCardSubtitle,
    ApplyIfNotEmptyDirective
  ],
  providers: [
    DatePipe
  ],
  standalone: true
})
export class CustomerInvoiceComponent {
  private route = inject(ActivatedRoute);
  translationService = inject(TranslationService);
  vHostService = inject(VHostService);
  customerService = inject(CustomerService);
  private platformId = inject<Object>(PLATFORM_ID);


  CssPropertiesEnum = CssPropertiesEnum;
  totalAmount : number;
  pageSize : number = 2;
  currentInvoices : InvoiceInfo[] = [];
  isLoading: boolean = false;
  cssPropertyPipe = new CssPropertyPipe();
  constructor() {
    const customerService = this.customerService;

    this.route.paramMap.subscribe((queryParams) => {
      this.pageSize = Number(queryParams.get("pageSize"));
    });
    customerService.getTotalNumberOfInvoices().subscribe( ta => {
      this.totalAmount = ta;
      if(isPlatformBrowser(this.platformId)) {
        this.loadInvoices();
      }
    });
  }

  loadInvoices(event : PageEvent = null) {
    this.isLoading = true;
    this.customerService.getInvoiceInfos(event? event.pageIndex : 0, event? event.pageSize : this.pageSize, null, null).subscribe(invoices => {
      this.currentInvoices = invoices;
      this.isLoading = false;
    });
  }

  hasCustomResponsivClasses() {
    return !!this.getCustomResponsivClasses();
  }

  getCustomResponsivClasses() {
    const t = this.cssPropertyPipe.transform;

    const classes = [
      'col-' + t(CssPropertiesEnum.customerFxFlex, this.vHostService),
      'col-sm-' + t(CssPropertiesEnum.customerFxFlexSM, this.vHostService),
      'col-md-' + t(CssPropertiesEnum.customerFxFlexMD, this.vHostService),
      'col-lg-' + t(CssPropertiesEnum.customerFxFlexLG, this.vHostService),
      'col-xl-' + t(CssPropertiesEnum.customerFxFlexXL, this.vHostService),
      'col-xxl-' + t(CssPropertiesEnum.customerFxFlexXXL, this.vHostService)
    ].join(' ');

    return /\d/.test(classes) ? classes : '';
  }
}
